import * as THREE from 'three';
import { Params } from '../data/Params';
import { GPUComputationRenderer, Variable } from 'three/examples/jsm/misc/GPUComputationRenderer';
import lifegameCalcFrag from "../glsl/lifegameCalc.frag";
import { p5Main } from '../myP5/p5Main';
import { RuleTex } from '../lifegame/RuleTex';
import { WebGLRenderer } from 'three';
//import glslify from 'glslify';
import { Random } from '../data/Random';


export class CACalculator{

    gpuCompute  :GPUComputationRenderer;
    variableLifeGame:Variable;
    p5Main      :p5Main;
    counter     :number = 0;
    rule        :number = 0;

    constructor(
        textureWidth:number,planeWidth:number,renderer:WebGLRenderer
    ){

        this.gpuCompute = new GPUComputationRenderer(
            textureWidth, textureWidth, renderer
        );
        const textureLifeGame = this.gpuCompute.createTexture();

        let l = textureLifeGame.image.data.length;
        let idx = 0;

        let randoms=[]
        for(let i=0;i<textureWidth;i++){
            randoms[i]=Random.value<0.5 ? 1 : 0;
        }

        for(let j=0;j<textureWidth;j++){
            for(let i=0;i<textureWidth;i++){

                textureLifeGame.image.data[idx + 0] = randoms[i];//i==Math.floor(textureWidth/2) ? 1 : 0;
                textureLifeGame.image.data[idx + 1] = 0;//g
                textureLifeGame.image.data[idx + 2] = 0.0;//b
                textureLifeGame.image.data[idx + 3] = 0.0;  
                idx += 4;

            }
        }


        this.variableLifeGame =this.gpuCompute.addVariable(
            "textureLifeGame",
            //antsCalcFrag,
            lifegameCalcFrag, 
            textureLifeGame
        );

        this.gpuCompute.setVariableDependencies(
            this.variableLifeGame,
            [this.variableLifeGame]
        );


        //compute用シェーダー
        let ruleTex = new RuleTex();
        let uniforms = this.variableLifeGame.material.uniforms;
        uniforms.counter = {value: 0};
        uniforms.planeSize = {value: new THREE.Vector2(planeWidth, planeWidth)};
        uniforms.rule = {value:this.rule};
        uniforms.ruleTex = {value:ruleTex.dataTex };
        uniforms.ruleTexSize = {value: ruleTex.size };
        uniforms.areaTex = { value: null };

        const error = this.gpuCompute.init();
        if (error !== null) {
          console.error(error);
        }

        Params.gui.add(this,"rule",0,255,1).listen();
        Params.gui.add(this,"nextRule");
        Params.gui.add(this,"prevRule");
    }

    public nextRule(){
        this.rule++;
        this.rule = this.rule%256;
    }
    public prevRule(){
        this.rule--;
        if(this.rule<0)this.rule=255;
    }    

    public init(callback:()=>void){


        //ここでp5
        this.p5Main = new p5Main();
        this.p5Main.init(()=>{
            callback();
        });
    
    }

    getCurrentTexture():THREE.Texture{
        return this.gpuCompute.getCurrentRenderTarget(this.variableLifeGame).texture;
    }
    getAltenateTexture():THREE.Texture{
        return this.gpuCompute.getAlternateRenderTarget(this.variableLifeGame).texture;
    }
    getAreaTexture():THREE.Texture{
        return this.p5Main.getCanvasTex();
    }



    public reset(){

        //this.p5Main._qTree.update(5);
        //this.p5Main._qTree.swapRandomly();

    }


    public update(){

        if(this.p5Main.getCanvasTex()==null)return;

        //return;
        this.variableLifeGame.material.uniforms.areaTex.value= this.p5Main.getCanvasTex();
        //this.material.uniforms.areaTex.value = this.p5Main.getCanvasTex();

        this.gpuCompute.compute();

        let tex = this.gpuCompute.getCurrentRenderTarget(this.variableLifeGame).texture;
        let tex2 = this.gpuCompute.getAlternateRenderTarget(this.variableLifeGame).texture;

        tex.magFilter=THREE.NearestFilter;
        tex.minFilter=THREE.NearestFilter;
        
        this.variableLifeGame.material.uniforms.rule.value = Math.floor(this.rule);
        this.variableLifeGame.material.uniforms.counter.value= this.counter;
        this.counter+=1;


        if(this.counter>Params.resolution+100){
            Params.preview();
        }


    }

}
